import { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
import MusicPlayer from '../../components/player/MusicPlayer';

const pageTitles = {
  '/admin/dashboard': 'Dashboard',
  '/admin/music': 'Music Releases',
  '/admin/shows': 'Shows & Events',
  '/admin/merch': 'Merchandise',
  '/admin/bookings': 'Bookings',
  '/admin/contacts': 'Contact Messages',
  '/admin/calendar': 'Calendar',
  '/admin/users': 'Team Members',
  '/admin/settings': 'Settings',
};

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  const title = pageTitles[location.pathname] || 'Admin';

  return (
    <div className="min-h-screen bg-black">
      {/* Sidebar */}
      <AdminSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      {/* Main Content */}
      <div className="md:ml-64">
        {/* Header */}
        <AdminHeader
          title={title}
          onMenuClick={() => setSidebarOpen(true)}
        />

        {/* Page Content */}
        <main className="p-6">
          <Outlet />
        </main>
      </div>

      {/* Music Player */}
      <MusicPlayer />
    </div>
  );
}
